import { render, staticRenderFns } from "./FooterVue.vue?vue&type=template&id=501c0e1c&scoped=true"
import script from "./FooterVue.vue?vue&type=script&lang=js"
export * from "./FooterVue.vue?vue&type=script&lang=js"
import style0 from "./FooterVue.vue?vue&type=style&index=0&id=501c0e1c&prod&lang=scss&scoped=true"
import style1 from "./FooterVue.vue?vue&type=style&index=1&id=501c0e1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501c0e1c",
  null
  
)

export default component.exports